export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑客户',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ custStatus }) => ['P', 'N'].includes(custStatus),
  },
  {
    text: that.$l('menu_text_delete') || '删除客户',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ custStatus }) => !['W', 'B'].includes(custStatus),
  },
  {
    text: that.$l('menu_text_apply') || '审核客户',
    icon: 'el-icon-check',
    menuType: 'apply',
    divided: true,
    allow: 'C',
    disabled: ({ custStatus }) => !['W', 'B'].includes(custStatus),
  },
  {
    text: that.$l('menu_text_change') || '变更客户',
    icon: 'el-icon-edit-outline',
    menuType: 'change',
    allow: 'F',
    disabled: ({ custStatus, modifyJson }) => {
      return custStatus !== 'Y' || !!modifyJson
    },
  },
  {
    text: that.$l('menu_text_detail_v2') || '查看详情V2',
    icon: 'el-icon-view',
    menuType: 'detailV2',
    allow: 'VD',
    divided: true,
  },
  {
    text: that.$l('menu_text_edit_v2') || '编辑客户V2',
    icon: 'el-icon-edit',
    menuType: 'editV2',
    allow: 'VM',
    disabled: ({ custStatus }) => ['P', 'N'].includes(custStatus),
  },
]
